/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SensorCreate { 
    Name: string;
    LocalId?: string | null;
    X?: number;
    Y?: number;
    AreaId: string;
}

